/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_baseLodash.js
// module id = 637
// module chunks = 0 1 2 3 4 5 6 7 8